// Filter panels fold away on small screens (CSS in stylesheets/_mobile.scss).
// Each panel gets a toggle button in its heading that shows how many filters are set,
// so a phone sees the list first and opens the filters only when needed.
// Panels without a heading (e.g. expenses) get one.

const activeCount = (body) => Array.from(body.querySelectorAll('select, input[type=text], input[type=search], input[type=date]'))
  .filter((field) => {
    if (!field.value) { return false; }
    // A select with no blank choice always has a value, so it only counts when it offers "All"
    return field.tagName !== 'SELECT' || Array.from(field.options).some((option) => option.value === '');
  }).length;

const updateLabel = (panel) => {
  const toggle = panel.querySelector('.filter-panel-toggle');
  const count = activeCount(panel.querySelector('.filter-panel-body'));
  toggle.querySelector('.filter-panel-count').textContent = count ? `${count} active` : '';
};

const setUp = (panel) => {
  const body = panel.querySelector('.filter-panel-body');
  if (!body || panel.querySelector('.filter-panel-toggle')) { return; }
  let heading = panel.querySelector('.filter-panel-heading');
  if (!heading) {
    heading = document.createElement('div');
    heading.className = 'filter-panel-heading';
    panel.prepend(heading);
  }
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'filter-panel-toggle';
  toggle.setAttribute('aria-expanded', 'false');
  toggle.innerHTML = '<span>Filters</span><span class="filter-panel-count"></span>';
  toggle.addEventListener('click', () => {
    const open = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  heading.prepend(toggle);
  body.addEventListener('change', () => updateLabel(panel));
  body.addEventListener('input', () => updateLabel(panel));
  updateLabel(panel);
};

const FilterPanels = {
  start: () => {
    document.addEventListener('turbolinks:load', () => document.querySelectorAll('.filter-panel').forEach(setUp));
  }
};

export { FilterPanels };
